import landing from './landing';
import common from './common';
import auth from './auth';
import shell from './shell';
import onboarding from './onboarding';
import portfolio from './portfolio';
import kanban from './kanban';
import modules from './modules';
import settings from './settings';
import gantt from './gantt';
import modals from './modals';
import account from './account';
import workspace from './workspace';
import sharing from './sharing';
import templates from './templates';

/**
 * Dicionário do português, dividido em NAMESPACES (um por área).
 *
 * O split existe porque `typeof` sobre um objeto único de milhares de chaves
 * produz erro de compilação ilegível e deixa o TypeScript lento. Cada namespace
 * é um arquivo, e a fronteira é o módulo do app: `landing`, `common`, e depois
 * `auth`, `shell`, `gantt`, `kanban`, `portfolio`...
 */
const pt = {
  landing,
  common,
  auth,
  shell,
  onboarding,
  portfolio,
  kanban,
  modules,
  settings,
  gantt,
  modals,
  account,
  workspace,
  sharing,
  templates,
};

/** en e es são tipados por esta forma. Chave faltando quebra o build. */
export type Dictionary = typeof pt;

export default pt;
